<template>
  <section class="hero is-primary">
    <div class="hero-body">
      <img src="../assets/dontomas-logo.gif" alt="Don Tomas" class="top-logo" />
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      subtitle: '"Veneris cervisiam opus"'
    }
  },
  methods: {
    changeSubtitle () {
      this.subtitle = '"Fredagsölen på jobbet"'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../assets/styles/config.scss';

section.hero {
  .hero-body {
    padding: 2rem 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .top-logo {
      width: 50%;
    }
  }

  &.is-primary {
    background-color: #f5f5f5;
  }
}
</style>



// WEBPACK FOOTER //
// AppHeader.vue?92d1b01a